import { Link } from "react-router";

interface ContactBannerProps {
  eyebrow: string;
  title: string;
  description: string;
  to: string;
  buttonLabel: string;
  imageSrc: string;
  imageAlt: string;
  eyebrowClassName?: string;
}

export function ContactBanner({
  eyebrow,
  title,
  description,
  to,
  buttonLabel,
  imageSrc,
  imageAlt,
  eyebrowClassName = "text-blue-200",
}: ContactBannerProps) {
  return (
    <div className="grid overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm md:grid-cols-2">
      <div className="relative min-h-[280px] md:min-h-full">
        <img src={imageSrc} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="flex flex-col justify-center bg-slate-950 px-8 py-10 text-white md:px-10">
        <p className={`text-sm font-semibold uppercase tracking-[0.2em] ${eyebrowClassName}`}>{eyebrow}</p>
        <h2 className="mt-4 text-3xl font-bold tracking-tight">{title}</h2>
        <p className="mt-4 max-w-md text-base text-slate-300">{description}</p>
        <div className="mt-8">
          <Link
            to={to}
            className="inline-flex rounded-xl bg-white px-5 py-3 font-semibold text-slate-950 transition hover:bg-slate-100"
          >
            {buttonLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}
